import styled from 'styled-components';

export const IframeContainer = styled.div`
  padding: 20px;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 16px;
  color: #ff0000;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;